module.exports = __webpack_public_path__ + "static/media/ImpresionBodega.1490cafb.png";